// extracted by mini-css-extract-plugin
export default {"poppins":"'Poppins', sans-serif","lightBlue":"#5956D6","lightPink":"#FF3964","white":"#fff","pinkHover":"#D32F53","btn":"style_btn__PGmlQ","btn_blur":"style_btn_blur__KabQg"};